import React, { useState } from 'react';
import { Dialog, Icon } from '@blueprintjs/core';
import { DialogContent } from './DialogContent';
import styles from './TransferApplicationDialog.module.css';

interface TransferApplicationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  applicationId: string;
  currentOwnerId?: string;
  marketCountry: string;
  assignmentType: string;
}

export const TransferApplicationDialog: React.FC<
  TransferApplicationDialogProps
> = ({
  isOpen,
  onClose,
  applicationId,
  currentOwnerId,
  marketCountry,
  assignmentType,
}) => {
  const [isTransferring, setIsTransferring] = useState(false);

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={
        <div id="transfer-dialog-title" className={styles.dialogHeader}>
          <Icon icon="tick-circle" />
          Transfer Ownership
        </div>
      }
      aria-labelledby="transfer-dialog-title"
      canEscapeKeyClose={!isTransferring}
      canOutsideClickClose={!isTransferring}
    >
      {isOpen && (
        <DialogContent
          onClose={onClose}
          applicationId={applicationId}
          currentOwnerId={currentOwnerId}
          marketCountry={marketCountry}
          assignmentType={assignmentType}
          onLoadingChange={setIsTransferring}
        />
      )}
    </Dialog>
  );
};
